import PersonIcon from '@mui/icons-material/Person';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import EmailIcon from '@mui/icons-material/Email';
import { Box, Button, Divider, Grid, Menu, MenuItem } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { HOST_API_URL } from '../../../../config-global';
import AwaitButton from '../../../../reusable-components/await-button/AwaitButton';
import { ConfirmDialog } from '../../../../reusable-components/confirm-dialog';
import DropdownAction from '../../../../reusable-components/dropdown-action/DropdownAction';
import Iconify from '../../../../reusable-components/iconify';
import { ScopeGuard } from '../../../../reusable-components/scopes';
import NewUserModal from './NewUserModal';
import   RolesTemplateTab from "./user/RolesTemplateTab";

const menuItemSx = {
  p: 0,
  minHeight: 'unset',
  '&:hover': {
    bgcolor: 'transparent',
  },
};

CustomToolbar.propTypes = {
  selected: PropTypes.array,
  setSelected: PropTypes.func,
  setShowSelection: PropTypes.func,
  showSelection: PropTypes.bool,
  deleteSelection: PropTypes.func,
  selectionType: PropTypes.string,
  setSelectionType: PropTypes.func,
  setOpenUserExcelUpload: PropTypes.func,
  setOpenCopyUser: PropTypes.func
};

export default function CustomToolbar({
  selected,
  setSelected,
  showSelection,
  setShowSelection,
  deleteSelection,
  selectionType,
  setSelectionType,
  setOpenUserExcelUpload,
  setOpenCopyUser
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (e) => {
    setAnchorEl(null);
  };
  const downloadUsers = async () => {
    //currently this is not working on dev environment as HOST_API_URL is not set but it will work on production
    window.open(`${HOST_API_URL}Api/Admin/User/DownloadUsersTable`, '_blank');
  };

  return (
    <>
      <Grid container direction="row" justifyContent="space-between" alignItems="flex-end">
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <ScopeGuard scopes={['User-Edit']} allowAdmin>
            <NewUserModal />
          </ScopeGuard>

          <Button
            variant="outlined"
            sx={{ mr: 1 }}
            size="small"
            color="secondary"
            onClick={downloadUsers}
            startIcon={<Iconify icon="mdi:tray-arrow-down" />}
          >
            Download
          </Button>

          <RolesTemplateTab />       

          <ScopeGuard scopes={['User-Edit']} allowAdmin>
            {!showSelection && (
              <Button
                color="secondary"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                variant="outlined"
                size="small"
                sx={{
                  mr: 1,
                  width: 30,
                  height: 30,
                  minWidth: 0,
                  p: '3px 4px',
                  flexShrink: 0,
                }}
              >
                <Iconify icon="mdi:more-vert" width={18} height={18} />
              </Button>
            )}
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              slotProps={{
                paper: {
                  sx: {
                    width: 253,
                    p: 1,
                    borderRadius: '5px',
                    boxShadow: '0px 2px 6px rgba(0,0,0,.06), 0px 8px 24px rgba(0,0,0,.12)',
                    '& .MuiMenu-list': {
                      p: 0,
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '14px',
                    },
                  },
                },
              }}
            >
              <ScopeGuard scopes={[]} allowAdmin>
                <MenuItem
                  disableRipple
                  disableGutters
                  sx={menuItemSx}
                  onClick={() => {
                    setAnchorEl(null);
                    setShowSelection(() => true);
                    setSelectionType('Enable');
                  }}
                >
                  <DropdownAction badgeIcon="mdi:account-check-outline">Enable Users</DropdownAction>
                </MenuItem>
                <MenuItem
                  disableRipple
                  disableGutters
                  sx={menuItemSx}
                  onClick={() => {
                    setAnchorEl(null);
                    setShowSelection(() => true);
                    setSelectionType('Disable');
                  }}
                >
                  <DropdownAction badgeIcon="mdi:account-off-outline">Disable Users</DropdownAction>
                </MenuItem>
                <MenuItem
                  disableRipple
                  disableGutters
                  sx={menuItemSx}
                  onClick={() => {
                    setAnchorEl(null);
                    setOpenCopyUser(true);
                  }}
                >
                  <DropdownAction badgeIcon="mdi:content-copy">Copy Users</DropdownAction>
                </MenuItem>
                <MenuItem
                  disableRipple
                  disableGutters
                  sx={menuItemSx}
                  onClick={() => {
                    setAnchorEl(null);
                    setShowSelection(() => true);
                    setSelectionType('Resend Email Confirmations');
                  }}
                >
                  <DropdownAction badgeIcon="mdi:email-sync-outline">Resend Confirmation Email</DropdownAction>
                </MenuItem>
                <MenuItem
                  disableRipple
                  disableGutters
                  sx={menuItemSx}
                  onClick={() => {
                    setAnchorEl(null);
                    setOpenUserExcelUpload(true);
                  }}
                >
                  <DropdownAction badgeIcon="mdi:account-multiple-plus-outline">Bulk Upload/Edit Users</DropdownAction>
                </MenuItem>
                {/* TODO: Bulk Update Users placeholder - not implemented yet */}
                {/* <MenuItem disableRipple disableGutters sx={menuItemSx} onClick={() => setAnchorEl(null)}>
                  <DropdownAction badgeIcon="mdi:account-cog-outline">Bulk Update Users</DropdownAction>
                </MenuItem> */}
                <Divider sx={{ my: '0 !important' }} />
                <MenuItem
                  disableRipple
                  disableGutters
                  sx={menuItemSx}
                  onClick={() => {
                    setAnchorEl(null);
                    setSelectionType('Delete');
                    setShowSelection(() => true);
                  }}
                >
                  <DropdownAction
                    badgeIcon="ic:outline-delete"
                    iconColor="error.main"
                    iconBgColor="#FDEDED"
                    textColor="error.main"
                  >
                    Delete Users
                  </DropdownAction>
                </MenuItem>
              </ScopeGuard>
            </Menu>
            {showSelection && (
              <>
                {selectionType === 'Disable' && (
                  <AwaitButton
                    color="warning"
                    variant="contained"
                    size="small"
                    startIcon={<PersonOffIcon />}
                    onClick={() => {
                      deleteSelection(selected);
                      setShowSelection(false);
                      setSelected([]);
                    }}
                  >
                    Disable
                  </AwaitButton>
                )}

                {selectionType === 'Enable' && (
                  <AwaitButton
                    color="primary"
                    variant="contained"
                    size="small"
                    startIcon={<PersonIcon />}
                    onClick={() => {
                      deleteSelection(selected);
                      setShowSelection(false);
                      setSelected([]);
                    }}
                  >
                    Enable
                  </AwaitButton>
                )}
                {selectionType === 'Resend Email Confirmations' && (
                  <AwaitButton
                    color="primary"
                    variant="contained"
                    size="small"
                    startIcon={<EmailIcon />}
                    onClick={() => {
                      deleteSelection(selected);
                      setShowSelection(false);
                      setSelected([]);
                    }}
                  >
                    Resend Email Confirmations
                  </AwaitButton>
                )}
                {selectionType === 'Delete' && (
                  <ConfirmDialog
                    button="contained"
                    icon="delete-outline"
                    title="Delete"
                    color="error"
                    content={`Are you sure you want to delete ${selected.length} users?`}
                    actionButton="Delete"
                    action={() => {
                      deleteSelection(selected);
                      setShowSelection(false);
                      setSelected([]);
                    }}
                    cancelAction={() => {
                      setShowSelection(false);
                      setSelected([]);
                    }}
                  />
                )}
                <Button
                  color="primary"
                  sx={{ textDecoration: 'underline' }}
                  onClick={() => {
                    setShowSelection(false);
                    setSelected([]);
                  }}
                >
                  Cancel
                </Button>
              </>
            )}
          </ScopeGuard>
        </Box>
      </Grid>
    </>
  );
}
